export const getTagColor = (key) => {
  const colors = {
    success: "green",
    pending: "yellow",
    cancelled: "red",
  };
  return colors[key];
};
